import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import { FaInstagram, FaFacebook, FaTiktok } from 'react-icons/fa';

const Footer = () => {
  const form = useRef();
  const [status, setStatus] = useState(''); // 'sending', 'success', 'error', ''

  useEffect(() => {
    if (status === 'success') {
      const timer = setTimeout(() => {
        setStatus('');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('sending');

    // These IDs come from the EmailJS dashboard. 
    // The user will need to replace them with their own unique IDs.
    // For now, I'll put placeholders.
    const serviceId = 'service_wlnzw09';
    const templateId = 'template_49kngc4';
    const publicKey = 'Fk7xsrLQmqFIKMCbx'; 

    emailjs.sendForm(serviceId, templateId, form.current, publicKey)
      .then((result) => {
          console.log(result.text);
          setStatus('success');
          form.current.reset();
      }, (error) => {
          console.log(error.text);
          setStatus('error');
      });
  };

  return (
    <footer style={{
      height: '100vh',
      scrollSnapAlign: 'start',
      padding: '2rem',
      background: 'var(--text-color)',
      color: 'var(--bg-color)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '3rem',
      textAlign: 'center',
      overflow: 'hidden',
      position: 'relative'
    }}>
      {/* Success Notification Popup */}
      <div style={{
        position: 'fixed',
        top: status === 'success' ? '20px' : '-100px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#8C9E85',
        color: '#fff',
        padding: '1rem 2rem',
        borderRadius: '50px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
        zIndex: 1000,
        transition: 'top 0.5s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        fontWeight: '500',
        letterSpacing: '0.5px'
      }}>
        Message sent successfully!
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <h2 style={{ fontSize: '3rem', margin: 0 }}>Let's Connect</h2>
        <p style={{ fontSize: '1.2rem', opacity: 0.8, lineHeight: 1.6 }}>
          Based in the Himalayas.<br/>
          Available for freelance projects.
        </p>
        <a href="mailto:pssonam25@gmail.com" style={{ 
          fontSize: '1rem', // Reduced resource request
          color: 'inherit', 
          textDecoration: 'none',
          borderBottom: '1px solid rgba(255,255,255,0.3)',
          paddingBottom: '0.2rem',
          width: 'fit-content',
          margin: '0 auto',
          opacity: 0.8
        }}>
          pssonam25@gmail.com
        </a>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        <h3 style={{ fontSize: '1.2rem', textTransform: 'uppercase', letterSpacing: '2px', opacity: 0.6 }}>Socials</h3>
        <div style={{ display: 'flex', gap: '3rem', fontSize: '2rem', justifyContent: 'center' }}>
          <a href="https://www.instagram.com/s0nam009?igsh=MThkN3lobXl6aG83bA==" target="_blank" style={{ color: 'inherit', transition: 'opacity 0.3s' }} className="social-link"><FaInstagram /></a>
          <a href="https://www.facebook.com/sonama.serpa.600816" target="_blank" style={{ color: 'inherit', transition: 'opacity 0.3s' }} className="social-link"><FaFacebook /></a>
          <a href="https://www.tiktok.com/@sherpa_lens?_r=1&_t=ZS-92NeKZFuX7F" target="_blank" style={{ color: 'inherit', transition: 'opacity 0.3s' }} className="social-link"><FaTiktok /></a>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', maxWidth: '400px' }}>
         <h3 style={{ fontSize: '1.2rem', textTransform: 'uppercase', letterSpacing: '2px', opacity: 0.6 }}>Contact Me</h3>
         
         <form ref={form} onSubmit={sendEmail} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
           <input 
              type="text" 
              name="user_name" 
              placeholder="Your Name" 
              required
              style={{
                background: 'transparent',
                border: 'none',
                borderBottom: '1px solid rgba(255,255,255,0.3)',
                color: 'inherit',
                padding: '0.8rem 0',
                width: '100%',
                outline: 'none',
                fontSize: '1rem'
              }} 
           />
           <input 
              type="email" 
              name="user_email" 
              placeholder="Your Email" 
              required
              style={{
                background: 'transparent',
                border: 'none',
                borderBottom: '1px solid rgba(255,255,255,0.3)',
                color: 'inherit',
                padding: '0.8rem 0',
                width: '100%',
                outline: 'none',
                fontSize: '1rem'
              }} 
           />
           <textarea 
              name="message" 
              placeholder="Your Message..." 
              required
              rows="3"
              style={{
                background: 'transparent',
                border: 'none',
                borderBottom: '1px solid rgba(255,255,255,0.3)',
                color: 'inherit',
                padding: '0.8rem 0',
                width: '100%',
                outline: 'none',
                fontSize: '1rem',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
           />
           
           <button 
              type="submit" 
              disabled={status === 'sending'}
              style={{
                 background: 'var(--accent-color)',
                 border: 'none',
                 color: '#fff',
                 padding: '0.8rem 1.5rem',
                 cursor: status === 'sending' ? 'not-allowed' : 'pointer',
                 textTransform: 'uppercase',
                 fontSize: '0.9rem',
                 letterSpacing: '1px',
                 marginTop: '0.5rem',
                 opacity: status === 'sending' ? 0.7 : 1,
                 transition: 'all 0.3s'
           }}>
             {status === 'sending' ? 'Sending...' : 'Send Message'}
           </button>

           {status === 'error' && <p style={{ color: '#ff6b6b', fontSize: '0.9rem' }}>Failed to send. Please try again.</p>}
         </form>

         <div style={{ fontSize: '0.9rem', opacity: 0.5, marginTop: '2rem' }}>
           © {new Date().getFullYear()} Sonam Sherpa.
         </div>
      </div>
    </footer>
  );
};

export default Footer;
